import { BackgroundImageHero } from '@time-line/components/common';
import type {
  BackgroundImage,
  CloudinaryVideo,
} from '@time-line/components/types';
import { VideoSplitHero } from 'components/heros/VideoSplitHero';
import type { ReactNode } from 'react';

interface HeroWrapperProps {
  isBadgeVisible?: boolean;
  backgroundImage?: BackgroundImage;
  video?: CloudinaryVideo;
  children: ReactNode;
}

export const HeroWrapper = ({
  backgroundImage,
  video,
  children,
  isBadgeVisible,
}: HeroWrapperProps) => {
  if (backgroundImage) {
    return (
      <BackgroundImageHero
        backgroundImage={backgroundImage}
        isBadgeVisible={isBadgeVisible}
        mobileBg="gray.100"
      >
        {children}
      </BackgroundImageHero>
    );
  }

  if (video) {
    return (
      <VideoSplitHero
        video={video}
        isBadgeVisible={isBadgeVisible}
        videoAspectRatio="1:1"
      >
        {children}
      </VideoSplitHero>
    );
  }

  return null;
};
